import { useEffect, useState } from "react";
import {
  FaChevronRight,
  FaCrown,
  FaFilePdf,
  FaGem,
  FaGoogle,
  FaPencilAlt,
  FaPercentage,
  FaSpinner,
  FaTag,
  FaVideo,
  FaYoutube,
} from "react-icons/fa";
import { toast } from "react-toastify";
import { BACKEND } from "../config/configEnvs";
import axios from "axios";
import * as React from "react";
import { FaHandshakeSimple, FaMeta } from "react-icons/fa6";
import { GiEmerald } from "react-icons/gi";
import bgBannerMc from "../assets/images/bgBannerMc.png";
import logoMc from "../assets/images/LOGO-VERSION-1-HORIZONTAL-MC.png";
import womanExample from "../assets/images/womanExample.png";
import imageGift from "../assets/images/imageGift.png";
import Tooltip from "../components/ui/ToolTip";
import { SiCanva } from "react-icons/si";
import LoadingScreen from "../components/ui/temp-screens/LoadingScreen";
import CalcularPrecioPais from "../utils/preciosPaises/calcularPrecioPais";
import ObtenerMoneda from "../utils/preciosPaises/ObtenerMoneda";
import CheckBox from "../components/ui/components/CheckBox";
import AutocompleteSelect from "../components/ui/components/AutocompleteSelect";

const PreciosPromociones = () => {
  const [services, setServices] = useState([]); // Lista de servicios
  const [servicesLoading, setSevicesLoading] = useState(false); // Estado de carga

  const [selectedService, setSelectedService] = useState("Seleccionar"); // Nombre del servicio seleccionado
  const [selectedServiceObject, setSelectedServiceObject] = useState({}); // Objeto del servicio seleccionado

  const [selectedScreen, setSelectedScreen] = useState("Precios");
  const [plansType, setPlansType] = useState("Principales"); // Lista de planes seleccionados

  const [countries, setCountries] = useState([]); // Lista de países
  const [selectedCountry, setSelectedCountry] = useState({}); // País seleccionado, Perú por defecto
  const [tiposCambio, setTiposCambio] = useState([]); // Lista de tipos de cambio

  const [comparePrices, setComparePrices] = useState(false);

  const getServices = async () => {
    // Obtenemos los servicios
    try {
      setSevicesLoading(true);
      const response = await axios.get(`${BACKEND}/api/servicios?limit=0`);
      setServices(response.data.docs);
      setSevicesLoading(false);
    } catch (error) {
      console.log(error);
      toast.error("Error al obtener los servicios");
    }
  };

  const getCountries = async () => {
    try {
      const response = await axios.get(`${BACKEND}/api/paises?limit=0`);
      setSelectedCountry(response.data.docs.find(c => c.name === "Perú"))
      setCountries(response.data.docs);
    } catch (error) {
      toast.error("Error al obtener los países");
    }
  };

  const getTipoCambio = async () => {
    try {
      const response = await axios.get(`${BACKEND}/api/tiposCambio?limit=0`);
      setTiposCambio(response.data.docs);
    } catch (error) {
      toast.error("Error al obtener el tipo de cambio");
    }
  }

  const parseDescription = (description) => {
    // Paseasmos la descripcion para poder meterla en la tabla de precios
    if (!description || typeof description !== "string") {
      return [];
    }

    return description.split("\n").map((item) => {
      const [key, value] = item.split(":");
      return {
        key: key ? key.trim() : "",
        value: value ? (value.trim() === "✓" ? "Sí" : value.trim()) : "No",
      };
    });
  };

  const hasPreciosUnitarios =
    selectedServiceObject?.preciosUnitarios?.length > 0; // Evaluamos si el servicio seleccionado tiene precios unitarios o no

  // Cada que cambia el nombre del servicio seleccionado, colocamos el objeto que coincide con el nombre en el estado local
  // Esto permite usar el objeto seleccionado y sus propiedades para la tabla secundaria
  useEffect(() => {
    const objectSelected = services.find(
      (service) => service.name === selectedService
    );
    setSelectedServiceObject(objectSelected || {});
    
    // Debug: ver qué planes tiene el servicio seleccionado
    if (objectSelected && objectSelected.preciosUnitarios) {
      console.log("Servicio:", objectSelected.name);
      console.log("Planes:", objectSelected.preciosUnitarios.map(p => ({ name: p.name, planName: p.plan.name })));
    }
  }, [selectedService, services]);

  // Funcion de arranque del componente
  useEffect(() => {
    getServices()
    getCountries()
    getTipoCambio()
  }, []);

  ////////////// Pantalla de promociones ////////////////////////

  // Mapeo de íconos
  const iconMap = {
    FaGem: FaGem,
    FaGoogle: FaGoogle,
    FaPercentage: FaPercentage,
    FaVideo: FaVideo,
    FaCrown: FaCrown,
    FaMeta: FaMeta,
    FaHandshakeSimple: FaHandshakeSimple,
    GiEmerald: GiEmerald,
  };

  const [timeLeft, setTimeLeft] = useState("00:00:00:00");

  // Todos los servicios
  const [offers, setOffers] = useState([]);

  // Servicios activos
  const [activeOffer, setActiveOffer] = useState({});

  // Obtenemos las promociones
  const getPromotions = async () => {
    try {
      const response = await axios.get(`${BACKEND}/api/promociones?limit=0`);
      const offersWithIcons = response.data.docs.map((offer) => ({
        ...offer,
        icon: iconMap[offer.icon] || null,
      }));
      setOffers(offersWithIcons);
      // Seleccionar el primer servicio de manera predeterminada
      if (offersWithIcons.length > 0) {
        setActiveOffer(offersWithIcons[0]);
      }
    } catch (error) {
      toast.error("Error obteniendo los servicios: " + error);
    }
  };

  // Procesar el texto del rich text
  const processImportantNotes = (notes) => {
    return notes.map((note, index) => {
      return note.children.map((child, childIndex) => {
        // Dividir el texto en partes usando un delimitador (en este caso, punto o viñeta)
        const points = child.text
          .split(/[\n•]/)
          .filter((point) => point.trim() !== "");

        return (
          <div key={`${index}-${childIndex}`} className="mb-2">
            {points.map((point, pointIndex) => (
              <p key={pointIndex} className="ml-4 list-disc text-sm">
                {/* Solo añadir el punto o viñeta en el primer elemento */}
                {pointIndex === 0 ? point.trim() : <>{point.trim()}</>}
              </p>
            ))}
          </div>
        );
      });
    });
  };

  // Reloj en vivo
  useEffect(() => {
    const interval = setInterval(() => {
      if (!activeOffer.endDate) {
        setTimeLeft("00:00:00:00");
        return;
      }

      const now = new Date();
      const endDate = new Date(activeOffer.endDate);
      const diff = endDate - now;

      if (diff <= 0) {
        setTimeLeft("00:00:00:00");
        clearInterval(interval);
        return;
      }

      const days = String(Math.floor(diff / (1000 * 60 * 60 * 24))).padStart(
        2,
        "0"
      );
      const hours = String(Math.floor((diff / (1000 * 60 * 60)) % 24)).padStart(
        2,
        "0"
      );
      const minutes = String(Math.floor((diff / (1000 * 60)) % 60)).padStart(
        2,
        "0"
      );
      const seconds = String(Math.floor((diff / 1000) % 60)).padStart(2, "0");

      setTimeLeft(`${days}:${hours}:${minutes}:${seconds}`);
    }, 1000);

    return () => clearInterval(interval);
  }, [activeOffer]);

  // Funciones de arranque de componente
  useEffect(() => {
    getPromotions();
  }, []);

  return (
    <div className="flex flex-col h-screen w-full">

      {/* Header */}
      <div className="flex flex-row px-4 py-2 bg-gray-100 mb-0.5">
        <div className="flex flex-row w-full items-center gap-4 justify-between overflow-x-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">

          {/* Titulo */}
          <div className="flex flex-row w-full items-center gap-4 justify-between">
            <div className="flex items-center gap-4 py-4">
              <FaTag className="text-zinc-700 text-2xl" />
              <h2
                className="text-2xl font-bold text-zinc-700 hover:cursor-pointer hover:text-orange-500 transition-all duration-200"
                onClick={() => setSelectedService("Seleccionar")}
              >
                Precios y promociones{" "}
              </h2>
            </div>
          </div>

          {/* Selectores */}
          <div className="flex flex-row items-center justify-center px-4">
            {selectedScreen === "Precios" && (
              <div className="flex flex-row items-center gap-4 mr-8">
                <img src={selectedCountry?.bandera?.url} alt={selectedCountry?.name} className="w-6 h-6" />
                <select
                  name="selectedCountry"
                  id="selectedCountry"
                  className="text-gray-700 text-xs bg-white border hover:cursor-pointer border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
                  value={selectedCountry?.id || "Seleccionar"}
                  onChange={(e) => {
                    const selectedCountryId = e.target.value;
                    const country = countries.find(c => c.id === selectedCountryId);
                    setSelectedCountry(country || {});
                  }}
                >
                  {countries.map((country) => (
                    <option key={country.id} value={country.id}>
                      {country.name}
                    </option>
                  ))}
                </select>
              </div>
            )}

            <select
              name="selectedScreen"
              id="selectedScreen"
              className="text-gray-700 mx-4 text-xs bg-white border hover:cursor-pointer border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
              value={selectedScreen}
              onChange={(e) => setSelectedScreen(e.target.value)}
            >
              <option value={"Precios"}>Precios</option>
              <option value={"Promociones"}>Promociones</option>
            </select>

            <AutocompleteSelect
              value={selectedService === "Seleccionar" ? "" : selectedService}
              setValue={(val) => setSelectedService(val || "Seleccionar")}
              minChars={0}
              options={[
                { value: "Seleccionar", label: "Todos los servicios" },
                ...services
                  .sort((a, b) => a.name.localeCompare(b.name))
                  .map((s) => ({ value: s.name, label: s.name })),
              ]}
              onSelectOption={(opt) => setSelectedService(opt?.value || "Seleccionar")}
              placeholder="Buscar servicio..."
              width={"200px"}
            />

            {selectedServiceObject.preciosUnitarios?.length > 3 && (
              <select
                name="selectedPlansType"
                id="selectedPlansType"
                className="text-gray-700 mx-4 text-xs bg-white border hover:cursor-pointer border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
                value={plansType}
                onChange={(e) => setPlansType(e.target.value)}
              >
                <option value={"Principales"}>Principales (Premium, Pro, Elite)</option>
                {selectedServiceObject.preciosUnitarios
                  .filter((precio) => precio.plan.name !== "Elite" && precio.plan.name !== "Pro" && precio.plan.name !== "Premium")
                  .map((precio, index) => (
                    <option key={index} value={precio.plan.name}>
                      {precio.plan.name}
                    </option>
                  ))}
              </select>
            )}

            {selectedService !== "Seleccionar" && (
              <div className="flex flex-row items-center gap-2 px-4">
                <span className="text-[10px]">
                  Comparar precios
                </span>
                <CheckBox
                  checked={comparePrices}
                  onChange={() => setComparePrices(!comparePrices)}
                />
              </div>
            )}

          </div>

        </div>
      </div>

      {/* Links del servicio */}
      {selectedService !== "Seleccionar" && (
        <div className="flex w-full flex-row items-center mb-0.5 py-1 justify-center bg-gray-100 gap-8">
          <span className="text-xs font-bold">
            Links del servicasdasdio:{" "}
          </span>
          <Tooltip content="Review video">
            <a
              href={selectedServiceObject.reviewVideo || "#"}
              target={selectedServiceObject.reviewVideo ? "_blank" : ""}
              rel="noopener noreferrer"
            >
              <FaYoutube
                className={`text-red-500 text-lg ${
                  !selectedServiceObject.reviewVideo
                    ? "opacity-10"
                    : "hover:cursor-pointer"
                }`}
              />
            </a>
          </Tooltip>
          <Tooltip content="Proyecto video">
            <a
              href={selectedServiceObject.proyectVideo || "#"}
              target={
                selectedServiceObject.proyectVideo ? "_blank" : ""
              }
              rel="noopener noreferrer"
            >
              <FaYoutube
                className={`text-red-500 text-lg ${
                  !selectedServiceObject.proyectVideo
                    ? "opacity-10"
                    : "hover:cursor-pointer"
                }`}
              />
            </a>
          </Tooltip>
          <Tooltip content="Making off video">
            <a
              href={selectedServiceObject.makingOffVideo || "#"}
              target={
                selectedServiceObject.makingOffVideo ? "_blank" : ""
              }
              rel="noopener noreferrer"
            >
              <FaYoutube
                className={`text-red-500 text-lg ${
                  !selectedServiceObject.makingOffVideo
                    ? "opacity-10"
                    : "hover:cursor-pointer"
                }`}
              />
            </a>
          </Tooltip>
          <Tooltip content="Casos de éxito">
            <a
              href={selectedServiceObject.successCaseVideo || "#"}
              target={
                selectedServiceObject.successCaseVideo ? "_blank" : ""
              }
              rel="noopener noreferrer"
            >
              <SiCanva
                className={`text-sky-500 text-lg ${
                  !selectedServiceObject.successCaseVideo
                    ? "opacity-10 cursor-not-allowed"
                    : "hover:cursor-pointer"
                }`}
              />
            </a>
          </Tooltip>
          <Tooltip content="Proceso y cronograma">
            <a
              href={selectedServiceObject.processCron || "#"}
              target={selectedServiceObject.processCron ? "_blank" : ""}
              rel="noopener noreferrer"
            >
              <SiCanva
                className={`text-sky-500 text-lg ${
                  !selectedServiceObject.processCron
                    ? "opacity-10"
                    : "hover:cursor-pointer"
                }`}
              />
            </a>
          </Tooltip>
        </div>
      )}

      {/* Body */}
      <div className="flex-grow overflow-y-auto">
        {selectedScreen === "Precios" ? (
          // Tabla servicios
            selectedService === "Seleccionar" ? (
              servicesLoading ? (
                <LoadingScreen />
              ) : (
                <table className="w-full">
                  <thead className="bg-white sticky top-0">
                    <tr className="text-gray-700 text-left text-sm uppercase font-semibold">
                      <td
                        className="px-6 py-3 text-center text-xs bg-[#FE6400] border-r border-r-white text-white border-red"
                        colSpan={1}
                        rowSpan={3}
                      >
                        Servicios
                      </td>
                      <td
                        className="px-6 py-3 text-center text-xs bg-[#FE6400] border-r border-r-white text-white border-red"
                        colSpan={1}
                        rowSpan={3}
                      >
                        Links
                      </td>
                      <td
                        className="px-6 py-3 text-center text-xs bg-green-500 border-gray-500 font-bold text-white"
                        colSpan={1}
                        rowSpan={1}
                      >
                        Elite
                      </td>
                      <td
                        className="px-6 py-3 text-center text-xs bg-blue-500 border-gray-500 font-bold text-white"
                        colSpan={1}
                        rowSpan={1}
                      >
                        Pro
                      </td>
                      <td
                        className="px-6 py-3 text-center text-xs bg-black border-gray-500 font-bold text-white"
                        colSpan={1}
                        rowSpan={1}
                      >
                        Premium
                      </td>
                    </tr>
                    <tr className="text-center text-xs border border-gray-300">
                      <td className="border border-gray-300">
                        Precio venta con impuestos
                      </td>
                      <td className="border border-gray-300">
                        Precio venta con impuestos
                      </td>
                      <td className="border border-gray-300">
                        Precio venta con impuestos
                      </td>
                    </tr>
                  </thead>

                  <tbody className="">
                    {services.map((service) => {
                      const precios = service.preciosUnitarios;

                      const precioEliteSinPais = precios.find((p) => p.plan.name === "Elite")?.precio || 0;
                      const precioProSinPais = precios.find((p) => p.plan.name === "Pro")?.precio || 0;
                      const precioPremiumSinPais = precios.find((p) => p.plan.name === "Premium")?.precio || 0;

                      const precioElite = CalcularPrecioPais({precio: precioEliteSinPais, multiplicador: selectedCountry.increasePercentage - selectedCountry.discountPercentage})
                      const precioPro = CalcularPrecioPais({precio: precioProSinPais, multiplicador: selectedCountry.increasePercentage - selectedCountry.discountPercentage})
                      const precioPremium = CalcularPrecioPais({precio: precioPremiumSinPais, multiplicador: selectedCountry.increasePercentage - selectedCountry.discountPercentage})

                      const moneda = ObtenerMoneda({pais: selectedCountry.name, paises: countries})
                      const tipoCambio = tiposCambio?.find((t) => t.moneda === moneda)?.tipoCambio || 1

                      const precioEliteMoneda = precioElite / tipoCambio
                      const precioProMoneda = precioPro / tipoCambio
                      const precioPremiumMoneda = precioPremium / tipoCambio

                      return (
                        <tr
                          key={service.id}
                          className="text-center text-xs border border-gray-300 "
                        >
                          <td className="text-center border border-gray-300 py-2">
                            {service.name}
                          </td>

                          <td className="text-center border border-gray-300 py-2">
                            <div className="flex flex-row w-full items-center gap-4 justify-center">
                              <Tooltip content="Review video">
                                <a
                                  href={service.reviewVideo || "#"}
                                  target={service.reviewVideo ? "_blank" : ""}
                                  rel="noopener noreferrer"
                                >
                                  <FaYoutube
                                    className={`text-red-500 text-lg ${
                                      !service.reviewVideo
                                        ? "opacity-10 cursor-not-allowed"
                                        : "hover:cursor-pointer"
                                    }`}
                                  />
                                </a>
                              </Tooltip>
                              <Tooltip content="Proyecto video">
                                <a
                                  href={service.proyectVideo || "#"}
                                  target={service.proyectVideo ? "_blank" : ""}
                                  rel="noopener noreferrer"
                                >
                                  <FaYoutube
                                    className={`text-red-500 text-lg ${
                                      !service.proyectVideo
                                        ? "opacity-10 cursor-not-allowed"
                                        : "hover:cursor-pointer"
                                    }`}
                                  />
                                </a>
                              </Tooltip>
                              <Tooltip content="Making off video">
                                <a
                                  href={service.makingOffVideo || "#"}
                                  target={
                                    service.makingOffVideo ? "_blank" : ""
                                  }
                                  rel="noopener noreferrer"
                                >
                                  <FaYoutube
                                    className={`text-red-500 text-lg ${
                                      !service.makingOffVideo
                                        ? "opacity-10 cursor-not-allowed"
                                        : "hover:cursor-pointer"
                                    }`}
                                  />
                                </a>
                              </Tooltip>
                              <Tooltip content="Casos de éxito">
                                <a
                                  href={service.successCaseVideo || "#"}
                                  target={
                                    service.successCaseVideo ? "_blank" : ""
                                  }
                                  rel="noopener noreferrer"
                                >
                                  <SiCanva
                                    className={`text-sky-500 text-lg ${
                                      !service.successCaseVideo
                                        ? "opacity-10 cursor-not-allowed"
                                        : "hover:cursor-pointer"
                                    }`}
                                  />
                                </a>
                              </Tooltip>
                              <Tooltip content="Proceso y cronograma">
                                <a
                                  href={service.processCron || "#"}
                                  target={service.processCron ? "_blank" : ""}
                                  rel="noopener noreferrer"
                                >
                                  <SiCanva
                                    className={`text-sky-500 text-lg ${
                                      !service.processCron
                                        ? "opacity-10 cursor-not-allowed"
                                        : "hover:cursor-pointer"
                                    }`}
                                  />
                                </a>
                              </Tooltip>
                            </div>
                          </td>

                          <td className="text-center border border-gray-300 py-2">
                            <span className={`px-3 py-1 ${precioElite === 0 ? "bg-red-400 text-white" : ""}`}>
                              {precioElite === 0 ? "No aplica" : `PEN. ${precioElite.toLocaleString("es-PE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} - `}
                              {moneda === "PEN" && precioElite !== 0 ? <span className="text-green-600 text-xs">
                                {" "} IGV (+18%): S/. {(precioElite + (precioElite * 0.18)).toLocaleString("es-PE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                              </span> : ""}
                              <span className="text-gray-400">
                                {moneda !== "PEN" && precioElite !== 0 && ` ${moneda}: ${precioEliteMoneda.toLocaleString("es-PE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}
                              </span>
                            </span>
                          </td>

                          <td className="text-center border border-gray-300 py-2">
                            <span className={`px-3 py-1 ${precioPro === 0 ? "bg-red-400 text-white" : ""}`}>
                              {precioPro === 0 ? "No aplica" : `PEN. ${precioPro.toLocaleString("es-PE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} - `}
                              {moneda === "PEN" && precioPro !== 0 ? <span className="text-green-600 text-xs">
                                {" "} IGV (+18%): S/. {(precioPro + (precioPro * 0.18)).toLocaleString("es-PE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                              </span> : ""}
                              <span className="text-gray-400">
                                {moneda !== "PEN" && precioPro !== 0 &&` ${moneda}: ${precioProMoneda.toLocaleString("es-PE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}
                              </span>
                            </span>
                          </td>

                          <td className="text-center border border-gray-300 py-2">
                            <span className={`px-3 py-1 ${precioPremium === 0 ? "bg-red-400 text-white" : ""}`}>
                              {precioPremium === 0 ? "No aplica" : `PEN. ${precioPremium.toLocaleString("es-PE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} - `}
                              {moneda === "PEN" && precioPremium !== 0 ? <span className="text-green-600 text-xs">
                                {" "} IGV (+18%): S/. {(precioPremium + (precioPremium * 0.18)).toLocaleString("es-PE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                              </span> : ""}
                              <span className="text-gray-400">
                                {moneda !== "PEN" && precioPremium !== 0 && ` ${moneda}: ${precioPremiumMoneda.toLocaleString("es-PE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}
                              </span>
                            </span>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              )
            ) : (
                comparePrices ? (
                 // Tabla simplificada solo para comparar precios
                 <table className="w-full">
                   <thead className="sticky top-0 z-30">
                     <tr className="text-gray-700 text-left text-sm uppercase font-semibold text-xs">
                       <td
                         className="px-6 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red"
                         colSpan={1}
                       >
                         Plan
                       </td>
                       <td
                         className="px-6 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red"
                         colSpan={1}
                       >
                         Precio con impuestos
                       </td>
                     </tr>
                   </thead>

                   <tbody>
                     {selectedServiceObject.preciosUnitarios?.map(
                       (precio, planIndex) => {
                         const precioPEN = CalcularPrecioPais({precio: precio.precio, multiplicador: selectedCountry.increasePercentage});
                         const moneda = ObtenerMoneda({pais: selectedCountry.name, paises: countries});
                         const tipoCambio = tiposCambio?.find((t) => t.moneda === moneda)?.tipoCambio || 1;
                         const precioMoneda = precioPEN / tipoCambio;
                         
                         return (
                           <tr key={planIndex} className="text-xs py-1 hover:cursor-pointer hover:bg-gray-100 transition-all duration-100">
                             <td className="px-4 py-2 border-b border-gray-200">
                               {precio.plan.name}
                             </td>
                             <td className="text-center border border-gray-300 px-4 py-1">
                               S/. {precioPEN.toLocaleString("es-PE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} - 
                               <span className="text-gray-400">
                                 {moneda === "PEN" && precioMoneda !== 0 && (
                                   <span className="text-green-600 whitespace-nowrap text-xs">
                                     {" "} IGV (+18%): S/. {(precioMoneda + (precioMoneda * 0.18)).toLocaleString("es-PE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                   </span>
                                 )}
                                 {moneda !== "PEN" && ` - ${moneda}: ${precioMoneda.toLocaleString("es-PE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}
                               </span>
                             </td>
                           </tr>
                         );
                       }
                     )}
                   </tbody>
                 </table>
              ) : (
                <table className="w-full">
                  <thead className="sticky top-0 z-30">
                    <tr className="text-gray-700 text-left text-sm uppercase font-semibold text-xs">
                      <td
                        className="w-1/3 px-6 sticky left-0 z-40 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red"
                        colSpan={1}
                        rowSpan={3}
                      >
                        Descripción
                      </td>
                      {hasPreciosUnitarios &&
                        (selectedServiceObject.preciosUnitarios?.length > 3 
                          ? (plansType === "Principales" 
                              ? selectedServiceObject.preciosUnitarios.filter((p) => p.plan.name === "Elite" || p.plan.name === "Pro" || p.plan.name === "Premium").map(
                                  (precio, index) => (
                                    <td
                                      key={index}
                                      className="px-6 z-40 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red"
                                      colSpan={1}
                                      rowSpan={3}
                                    >
                                      {precio.plan.name}
                                    </td>
                                  )
                                )
                              : selectedServiceObject.preciosUnitarios.filter((p) => p.plan.name === plansType).map(
                                  (precio, index) => (
                                    <td
                                      key={index}
                                      className="px-6 py-3 z-40 text-center bg-[#FE6400] border-r border-r-white text-white border-red"
                                      colSpan={1}
                                      rowSpan={3}
                                    >
                                      {precio.plan.name}
                                    </td>
                                  )
                                )
                            )
                          : selectedServiceObject.preciosUnitarios.map(
                              (precio, index) => (
                                <td
                                  key={index}
                                  className="px-6 py-3 z-40 text-center bg-[#FE6400] border-r border-r-white text-white border-red"
                                  colSpan={1}
                                  rowSpan={3}
                                >
                                  {precio.plan.name}
                                </td>
                              )
                            )
                        )
                      }
                    </tr>
                    {/* Concepto se mostrará como primera fila del tbody */}
                  </thead>

                  <tbody>
                    <tr className="text-xs py-1 hover:cursor-pointer hover:bg-gray-100 transition-all duration-100">
                      <td className="px-4 py-2 sticky left-0 z-10 border-b bg-white border-gray-200">
                        Concepto
                      </td>
                      {(selectedServiceObject.preciosUnitarios?.length > 3 
                          ? (plansType === "Principales" 
                              ? selectedServiceObject.preciosUnitarios.filter((p) => p.plan.name === "Elite" || p.plan.name === "Pro" || p.plan.name === "Premium")
                              : selectedServiceObject.preciosUnitarios.filter((p) => p.plan.name === plansType)
                            )
                          : selectedServiceObject.preciosUnitarios || []
                        ).map((precio, planIndex) => {
                          return (
                            <td key={planIndex} className="text-center border border-gray-300 px-4 py-1">
                              {precio.concepto || "-"}
                            </td>
                          );
                        })
                      }
                    </tr>
                    {hasPreciosUnitarios &&
                      parseDescription(
                        selectedServiceObject.preciosUnitarios?.length > 3 
                          ? (plansType === "Principales" 
                              ? selectedServiceObject.preciosUnitarios.filter((p) => p.plan.name === "Elite" || p.plan.name === "Pro" || p.plan.name === "Premium")[0]?.descripcion
                              : selectedServiceObject.preciosUnitarios.find((p) => p.plan.name === plansType)?.descripcion
                            )
                          : selectedServiceObject.preciosUnitarios[0]?.descripcion
                      ).map((descItem, index) => (
                        <tr
                          key={index}
                          className="text-xs py-1 z-10 hover:cursor-pointer hover:bg-gray-100 transition-all duration-100"
                        >
                          <td className="px-4 py-2 sticky left-0 z-10 bg-white border-b border-gray-200">
                            {descItem.key}
                          </td>
                            {(selectedServiceObject.preciosUnitarios?.length > 3 
                              ? (plansType === "Principales" 
                                  ? selectedServiceObject.preciosUnitarios.filter((p) => p.plan.name === "Elite" || p.plan.name === "Pro" || p.plan.name === "Premium")
                                  : selectedServiceObject.preciosUnitarios.filter((p) => p.plan.name === plansType)
                                )
                              : selectedServiceObject.preciosUnitarios
                            ).map(
                            (precio, planIndex) => {
                              const parsedDescription = parseDescription(
                                precio.descripcion
                              );
                              const correspondingItem = parsedDescription.find(
                                (item) => item.key === descItem.key
                              );

                              return (
                                <td
                                  key={planIndex}
                                  className="text-center border border-gray-300 px-4 py-1"
                                >
                                  {correspondingItem
                                    ? correspondingItem.value
                                    : "No"}
                                </td>
                              );
                            }
                          )}
                        </tr>
                      ))
                    }
                    <tr className="text-xs py-1 hover:cursor-pointer hover:bg-gray-100 transition-all duration-100 bg-orange-100 hover:bg-orange-200 font-bold">
                      <td className="px-4 py-2 border-b border-gray-200">
                        Precio con impuestos
                      </td>
                      {(selectedServiceObject.preciosUnitarios?.length > 3 
                          ? (plansType === "Principales" 
                              ? selectedServiceObject?.preciosUnitarios?.filter((p) => p.plan.name === "Elite" || p.plan.name === "Pro" || p.plan.name === "Premium")
                              : selectedServiceObject?.preciosUnitarios?.filter((p) => p.plan.name === plansType)
                            )
                          : selectedServiceObject?.preciosUnitarios
                        )?.map(
                        (precio, planIndex) => {
                          const precioPEN = CalcularPrecioPais({precio: precio.precio, multiplicador: selectedCountry.increasePercentage});
                          const moneda = ObtenerMoneda({pais: selectedCountry.name, paises: countries});
                          const tipoCambio = tiposCambio?.find((t) => t.moneda === moneda)?.tipoCambio || 1;
                          const precioMoneda = precioPEN / tipoCambio;
                          
                          return (
                            <td key={planIndex} className="text-center border border-gray-300 px-4 py-1">
                              S/. {precioPEN.toLocaleString("es-PE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} - 
                              <span className="text-gray-400">
                                {moneda === "PEN" && precioMoneda !== 0 && (
                                  <span className="text-green-600 text-xs">
                                    {" "} IGV (+18%): S/. {(precioMoneda + (precioMoneda * 0.18)).toLocaleString("es-PE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                  </span>
                                )}
                                {moneda !== "PEN" && ` - ${moneda}: ${precioMoneda.toLocaleString("es-PE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}
                              </span>
                            </td>
                          );
                        }
                      )}
                    </tr>
                  </tbody>
                  
                </table>
              )
            )
        ) : (
          // Tabla promociones
          <div>
            {/* Tabs */}
            <div className="flex flex-row items-center justify-between">
              <ul className="flex flex-row justify-start text-sm font-medium text-center border-b border-white">
                {offers.map((e) => (
                  <li key={e.id}>
                    <button
                      onClick={() => setActiveOffer(e)}
                      type="button"
                      className={`${
                        activeOffer.id === e.id
                          ? "bg-orange-500 text-white border-orange-500"
                          : "bg-orange-100 text-orange-700 border-transparent"
                      } px-4 py-2 rounded-t-md border cursor-pointer flex flex-row items-center gap-2 transition-all duration-300 ease-in-out hover:bg-orange-200 hover:text-orange-800`}
                    >
                      {`${e.titleService}`}
                      {e.icon && <e.icon className="text-xl" />}
                    </button>
                  </li>
                ))}
              </ul>
            </div>

            <div className="flex flex-row py-4 px-4 gap-4 overflow-y-auto font-poppins border border-gray-300 rounded-b-lg">
              {/* Tabla */}
              <div className="w-full md:w-2/3 overflow-y-auto max-h-[80vh]">
                <table className="w-full">
                  {(activeOffer.extraTextColumn1 ||
                    activeOffer.extraTextColumn2) && (
                    <thead className="bg-white top-0">
                      <tr className="text-gray-700 text-left text-sm font-light italic">
                        <th className="px-6 py-3 text-center" colSpan={2}></th>
                        <th className="px-6 py-3 text-center bg-white border border-orange-200 font-light text-black">
                          {activeOffer?.extraTextColumn1}
                        </th>
                        <th className="px-6 py-3 text-center bg-white border border-orange-200 font-light text-black">
                          {activeOffer?.extraTextColumn2}
                        </th>
                      </tr>
                    </thead>
                  )}

                  <thead className="bg-white sticky top-0">
                    <tr className="text-gray-700 text-left text-sm uppercase font-semibold">
                      <th className="px-6 py-3 text-center" colSpan={2}></th>
                      <th className="px-6 py-3 text-center bg-orange-200 border-r border-orange-500 font-bold text-orange-500">
                        {activeOffer?.titleColumn1}
                      </th>
                      <th className="px-6 py-3 text-center bg-orange-200 border-l border-orange-500 font-bold text-orange-500">
                        {activeOffer?.titleColumn2}
                      </th>
                    </tr>
                  </thead>

                  <thead className="bg-white sticky top-11">
                    <tr className="text-gray-700 text-left text-sm uppercase font-semibold">
                      <th
                        className="px-6 py-3 text-center border-b border-b-orange-200"
                        colSpan={2}
                      ></th>
                      <th className="px-6 py-3 text-center bg-orange-500 border-r border-white font-bold text-white">
                        {activeOffer?.subtitleColumn1}
                      </th>
                      <th className="px-6 py-3 text-center bg-orange-500 border-l border-white font-bold text-white">
                        {activeOffer?.subtitleColumn2}
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {offers
                      .filter((offer) => offer.id === activeOffer.id)
                      .map((offer) =>
                        offer.plans.map((plan, index) => {
                          const colors = [
                            "bg-orange-200",
                            "bg-orange-300",
                            "bg-orange-400",
                            "bg-orange-500",
                          ];
                          const colorClass = colors[index % colors.length];

                          return (
                            <React.Fragment key={plan.id}>
                              <tr>
                                <td
                                  className={`w-[16%] text-center font-bold text-lg ${colorClass}`}
                                  rowSpan={plan.rows.length + 1}
                                >
                                  {plan.name}
                                </td>
                              </tr>
                              {plan.rows.map((row) => (
                                <tr key={row.id}>
                                  <td
                                    className={`text-center text-xs border border-orange-200 ${
                                      row.isPrice
                                        ? "bg-red-200 text-red-500"
                                        : ""
                                    } px-4 font-bold py-2 `}
                                  >
                                    {row.rowTitle}
                                  </td>
                                  <td
                                    className={`border text-xs px-4 text-center py-2 border-orange-200 ${
                                      row.isPrice
                                        ? "bg-red-200 text-red-500"
                                        : ""
                                    } ${
                                      row.isTextFontBold ? "font-bold" : ""
                                    } ${
                                      row.isTextSlashed ? "line-through" : ""
                                    } ${row.isTextItalic ? "italic" : ""}`}
                                  >
                                    {row.proPlan}
                                  </td>
                                  <td
                                    className={`border text-xs px-4 text-center py-2 border-orange-200 ${
                                      row.isPrice
                                        ? "bg-red-200 text-red-500"
                                        : ""
                                    } ${
                                      row.isTextFontBold ? "font-bold" : ""
                                    } ${
                                      row.isTextSlashed ? "line-through" : ""
                                    } ${row.isTextItalic ? "italic" : ""}`}
                                  >
                                    {row.premiumPlan}
                                  </td>
                                </tr>
                              ))}
                            </React.Fragment>
                          );
                        })
                      )}
                  </tbody>
                </table>
                <div>
                  {activeOffer.importantNotes &&
                    activeOffer.importantNotes.length > 0 && (
                      <div className="important-notes px-4 py-6 border border-orange-200 rounded-lg mt-4">
                        <h3 className="text-lg font-semibold">
                          Notas Importantes: <br />{" "}
                        </h3>
                        {processImportantNotes(activeOffer.importantNotes)}
                      </div>
                    )}
                </div>
              </div>

              {/* Banner */}
              <div className="hidden relative md:flex h-[80vh] text-black text-center rounded-lg overflow-hidden">
                <img
                  src={bgBannerMc}
                  alt="MC-offers"
                  className="w-full h-full object-cover"
                />

                <img
                  src={imageGift}
                  alt="MC-offers"
                  className="absolute w-[50%] right-0 top-12"
                />

                {/* Primera seccion */}
                <div className="absolute w-full h-[20%] gap-2 flex flex-col items-center justify-center px-4">
                  <div className="w-full flex flex-row gap-2 items-center justify-center text-white font-semibold lg:px-4 xl:px-4 py-0.5 rounded-lg gap-2">
                    <span className="font-bold text-[#072142] md:text-3xl lg:text-3xl xl:text-3xl">
                      Quedan:
                    </span>

                    <div className="font-bold bg-[#FE6400] px-4 rounded-lg md:text-3xl lg:text-3xl xl:text-3xl">
                      {timeLeft}
                    </div>
                  </div>

                  <div className="w-full flex items-center justify-center">
                    <div className="w-[30%]">
                      <img src={logoMc} alt="MC-logo" className="" />
                    </div>
                  </div>
                </div>

                {/* Segunda seccion */}
                <div className="absolute w-full h-[25%] mt-[25%] flex flex-col items-start justify-between px-8 text-left">
                  <span className="text-[#4B5563] text-base md:text-xl lg:text-2xl xl:text-3xl font-bold">
                    {activeOffer?.bannerText?.titleBannerLine1}
                  </span>

                  <span className="text-[#FE6400] text-base md:text-2xl lg:text-3xl xl:text-4xl font-bold">
                    {activeOffer?.bannerText?.titleBannerLine2}
                  </span>

                  <span className="text-[#4B5563] text-base md:text-md lg:text-md xl:text-md">
                    {activeOffer?.bannerText?.titleBannerLine3}
                  </span>
                </div>

                {/* Tercera sección */}

                <div className="absolute bottom-12 w-full h-[45%] flex flex-row px-4">
                  <div className="w-1/3 h-full flex flex-col justify-end overflow-visible">
                    <img
                      src={womanExample}
                      alt="womanExample"
                      className="w-auto object-contain"
                    />
                  </div>

                  <div className="flex flex-col justify-end py-8">
                    <div className="flex flex-row">
                      <span className="text-base md:text-7xl lg:text-[170px] xl:text-[230px] font-bold text-[#072142]">
                        {activeOffer?.bannerText?.discountPercentage}
                      </span>
                      <span className="text-base md:text-4xl lg:text-[40px] xl:text-[50px] font-bold text-[#072142] flex flex-col justify-end">
                        %
                      </span>
                    </div>

                    <div className="flex flex-col justify-end">
                      <span className="text-base md:text-xl lg:text-2xl xl:text-3xl font-bold text-[#072142] text-start px-4">
                        De descuento
                      </span>
                    </div>
                  </div>
                </div>

                <div className="absolute bottom-0 text-[#072142] text-xs bg-[#F3F4F6] py-4 w-full">
                  <span className="font-bold">Términos y Condiciones: </span>
                  <span>
                    Esta promoción estará vigente hasta el{" "}
                    {activeOffer?.endDate &&
                      new Date(activeOffer.endDate)
                        .toLocaleDateString("es-ES", {
                          day: "2-digit",
                          month: "2-digit",
                          year: "numeric",
                        })
                        .replace(/\//g, "/")}
                  </span>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

    </div>
  );
};

export default PreciosPromociones;
